/* ==========================================================================
   Egaline Totaal — et-artikel.js (handoff-2, spec 3d)
   TOC in de artikelsidebar: indexeert de H2's uit de artikelcontent,
   bouwt de INHOUD-lijst en volgt de scrollpositie (actieve link krijgt
   .is-actief = teal accentlijn + navy tekst). Zonder H2's blijft de
   TOC-kaart verborgen (hidden-attribuut in main-article.liquid).
   ========================================================================== */
(function () {
  'use strict';

  function slugify(tekst, index) {
    var slug = (tekst || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9À-ɏ]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return slug || 'sectie-' + (index + 1);
  }

  function init() {
    var body = document.querySelector('[data-et-artikel-body]');
    var kaart = document.querySelector('[data-et-artikel-toc]');
    var lijst = document.querySelector('[data-et-artikel-toc-lijst]');
    if (!body || !kaart || !lijst) return;

    var koppen = Array.prototype.slice.call(body.querySelectorAll('h2'));
    if (!koppen.length) return;

    var links = koppen.map(function (kop, i) {
      if (!kop.id) {
        var id = slugify(kop.textContent, i);
        // uniek houden bij dubbele koptitels
        var uniek = id;
        var n = 2;
        while (document.getElementById(uniek)) {
          uniek = id + '-' + n;
          n++;
        }
        kop.id = uniek;
      }
      var a = document.createElement('a');
      a.href = '#' + kop.id;
      a.textContent = kop.textContent;
      lijst.appendChild(a);
      return a;
    });

    kaart.hidden = false;

    var actief = -1;
    function update() {
      var y = window.scrollY + 130;
      var idx = 0;
      for (var i = 0; i < koppen.length; i++) {
        if (koppen[i].getBoundingClientRect().top + window.scrollY <= y) {
          idx = i;
        }
      }
      if (idx === actief) return;
      actief = idx;
      links.forEach(function (link, i) {
        link.classList.toggle('is-actief', i === idx);
      });
    }

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
